module.exports = __webpack_public_path__ + "img/under-construction.290d9221.svg";